import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import urls, { codeUrl } from '@/constants/urls';
import PositiveToast from '@/components/toasts/PositiveToast';

const DatasetAttachmentCreatedToast = ({ code, name, filename }) => (
  <PositiveToast className="aridhia-dataset-attachment-created-toast">
    <FormattedMessage id="dataset.attachment.attached.to.success" values={{ filename }} />
    <Link to={codeUrl(urls.DATASETS, code)}>
      {name}
    </Link>
  </PositiveToast>
);

export default DatasetAttachmentCreatedToast;
